/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as productsSlice from './productsSlice';

export default function* watchProductsSaga() {
 yield takeLatest(productsSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(productsSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(productsSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(productsSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(productsSlice.deleteItemsStart.type, commonSagas.deleteItems);
 yield takeLatest(productsSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  productsSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  productsSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  productsSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  productsSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  productsSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
